<template>
  <div id="app">
    <div v-if="siteIsDown">
      <h1>Portalen er nede mens vi fikser ting ;)</h1>
      <img src="https://pbs.twimg.com/profile_images/757576261074124804/eQfLnDDl.jpg" alt="">
    </div>
    <div v-else>
    <nav-bar v-if="!$route.meta.hideNavigation" />
    <main>
      <router-view />
      <!-- <error /> -->
    </main>
    <cookie-law
      message="Dette nettstedet benytter informasjonskapsler (cookies) for optimalisering av tjenesten, samt statistikk- og analyseformål. Du gir ditt samtykke ved å klikke på OK."
      buttonText="OK"
      theme="get"
    ></cookie-law>
    <Footer />
    </div>
  </div>
</template>
<script>
import NavBar from "@/components/NavBar";
import Footer from "@/components/Footer";
// https://www.npmjs.com/package/vue-cookie-law <-- dokumentasjon for bruk av denne
import CookieLaw from "vue-cookie-law";

// import Error from "./components/Error";

export default {
  data() {
    return {
      siteIsDown: false,
    }
  },
  components: {
    NavBar,
    Footer,
    CookieLaw,
    // Error
  },
};
</script>

<style lang="scss">
// @import url("https://fonts.googleapis.com/css2?family=Roboto:ital,wght@0,400;0,700;1,400;1,700&display=swap");
@import url("https://fonts.googleapis.com/css2?family=Poppins:ital,wght@0,400;0,600;1,400;1,600&display=swap");
// @import url('https://fonts.googleapis.com/css?family=Poppins');

:root {
  --primary-color: #ee7100;
  --secondary-color: #61a1cb;
  --dark-color: #333333;
  --light-color: #fffbf8;
  --white-color: #ffffff;
  --red-color: #dc3545;
  --primary-border-color: #d6d6d6;
  --secondary-background-color: #e4f5ff;
  --sedoncary-button-color: #61a1cb;
  --sedoncary-button-radius: 15px;
  --content-width: 1100px;
  --border-radius: 5px;
  // --margin-sides: 2.5em;
  --margin-sides: 0;
  --box-shadow: 0 4px 10px 0 rgba(0, 0, 0, 0.2);
}

/*
 * Evt. reset når/hvis vi trenger det.
 */
// * {
//   vertical-align: baseline;
//   font-weight: inherit;
//   font-family: inherit;
//   font-style: inherit;
//   font-size: 100%;
//   border: 0 none;
//   outline: 0;
//   padding: 0;
//   margin: 0;
// }

body {
  font-family: "Poppins", sans-serif;
  letter-spacing: 0.5px;
  margin: 0;
  background-color: var(--white-color);
}

#app {
  color: var(--dark-color);
  width: 100%;
  background-color: var(--white-color);
}

main,
.main-content {
  max-width: var(--content-width);
  margin: 0 auto;
  // margin-bottom: 2em;

  & > * {
    min-height: 700px;
    // padding-top: 2em;

    & > * {
      // max-width: var(--content-width);
      // margin: 0;
    }
  }
}

.button,
button {
  /*
   * Ulike nettlesere har ulike button-stylinger, dette må ordnes:
   */
  font: inherit;
  font-weight: bold;
  line-height: 1.15;
  margin: 0;

  /* 
   * Vår styling:
   */
  display: inline-block;
  cursor: pointer;
  background-color: var(--primary-color);
  // background-color: white;
  padding: 10px;
  // box-shadow: 0.1rem 0.1rem 1rem rgba(0, 0, 0, 0.1);
  border-radius: var(--border-radius);
  border: 0;
  outline: 0;
  color: white;
  text-align: center;

  // Quickfix for at knappene ikke skal være klistret i hverandre.
  margin-right: 5px;

  :disabled {
    background-color: lightgrey;
  }
}

button.primary,
.button.primary {
  background-color: var(--primary-color);
}
.button-cancel {
  color: var(--dark-color);
  background-color: white;
  border: 1px solid black;
}
button.secondary,
.button.secondary {
  background-color: var(--secondary-color);
}

button.danger,
.button.danger {
  background-color: var(--red-color);
}

a.button {
  text-decoration: none;
}
.button-signin {
  color: #94a2b0;
}
.button-signout {
  margin: 10px 0;
  letter-spacing: 0.0625em;
  background-color: var(--white-color);
  border: 1px solid var(--secondary-color);
  border-radius: 5rem;
  color: var(--secondary-color);
  padding: 5px 10px;
}
.button-signout:hover {
  background-color: var(--secondary-color);
  border: 1px solid var(--secondary-color);
  border-radius: 5rem;
  color: var(--white-color);
}
a {
  text-decoration: underline;
  color: inherit;

  &:hover {
    text-decoration: none;
    border-bottom: 0;
  }
}

.icon-container {
  display: flex;
  float: right;
  margin: auto;
  box-shadow: inset 0px -3px 7px 0px #29bbff;
  background: linear-gradient(to bottom, #2dabf9 5%, #2196f3 100%);
  background-color: #2196f3;
  border-radius: 7px;
  display: inline-block;
  padding: 6px 10px;
  width: 23px;
  height: 27px;
  cursor: pointer;
}
.icon-container:hover {
  background: linear-gradient(to bottom, #2196f3 5%, #2dabf9 100%);
  background-color: #0688fa;
}

.icon-container:active {
  position: relative;
  top: 1px;
}

.icon-button {
  color: white;
  font-size: 25px;
}

.colored-icon {
  color: #2196f3;
}

select {
  padding: 0.75em;
}

input,
select,
textarea {
  width: 50%;
  box-sizing: border-box;
  padding: 1ch;
  font: inherit;
  border-radius: 5px;
  border: 1px solid var(--primary-border-color);
  transition: 0.3s border-color;

  &:hover {
    border: 1px solid rgb(165, 165, 167);
  }
}

input[type="checkbox"] {
  cursor: pointer;
}

.Cookie--get .Cookie__button {
  background: #339966;
  padding: 0.625em 3.125em;
  color: white;
  border-radius: 5px;
  border: 0;

  font-size: 1em;
  font-family: Poppins, sans-serif;
}
.Cookie--get .Cookie__button:hover {
  background: #5caa83;
}
.Cookie--get {
  background-color: #444547e1;
  color: white;
  padding: 2rem 5rem;
  justify-content: center;
}
.Cookie--get .Cookie__content {
  max-width: 1000px;
}

//Dette er kodeblokkene i obligene
code {
}
@media only screen and (max-width: 768px) {
  main,
  .main-content {
    padding: 1rem;
  }
  code {
    white-space: pre-line;
  }
  iframe {
    width: 100%;
  }
  input[type="text"],
  textarea {
    width: 100%;
  }
}
</style>
